export const COUNTRY = [
    {code: "AF", name: "AFGHANISTAN"},
    {code: "AX", name: "ILES ALAND"},
    {code: "AL", name: "ALBANIE"},
    {code: "DZ", name: "ALGÉRIE"},
    {code: "AS", name: "SAMOA AMÉRICAINES (TERRITOIRE DE)"},
    {code: "AD", name: "ANDORRE"},
    {code: "AO", name: "ANGOLA"},
    {code: "AI", name: "ANGUILLA"},
    {code: "AQ", name: "ANTARTIQUE"},
    {code: "AG", name: "ANTIGUA-ET-BARBUDA"},
    {code: "AR", name: "ARGENTINE"},
    {code: "AM", name: "ARMÉNIE"},
    {code: "AW", name: "ARUBA"},
    {code: "AU", name: "AUSTRALIE"},
    {code: "AT", name: "AUTRICHE"},
    {code: "AZ", name: "AZERBAIDJAN"},
    {code: "BS", name: "BAHAMAS"},
    {code: "BH", name: "BAHREÏN"},
    {code: "BD", name: "BANGLADESH"},
    {code: "BB", name: "BARBADE"},
    {code: "BY", name: "BIELORUSSIE"},
    {code: "BE", name: "BELGIQUE"},
    {code: "BZ", name: "BELIZE"},
    {code: "BJ", name: "BÉNIN"},
    {code: "BM", name: "BERMUDES"},
    {code: "BT", name: "BHOUTAN"},
    {code: "BO", name: "BOLIVIE"},
    {code: "BQ", name: "BONAIRE, SAINT EUSTATIUS et SABA"},
    {code: "BA", name: "BOSNIE HERZÉGOVINE"},
    {code: "BW", name: "BOTSWANA"},
    {code: "BV", name: "ÎLE BOUVET"},
    {code: "BR", name: "BRÉSIL"},
    {code: "IO", name: "TERRITOIRES BRITANNIQUES DE L'OCÉAN INDIEN"},
    {code: "BN", name: "BRUNEI DARUSSALAM"},
    {code: "BG", name: "BULGARIE"},
    {code: "BF", name: "BURKINA FASO"},
    {code: "BI", name: "BURUNDI"},
    {code: "KH", name: "CAMBODGE"},
    {code: "CM", name: "CAMEROUN"},
    {code: "CA", name: "CANADA"},
    {code: "CV", name: "CAP-VERT"},
    {code: "KY", name: "ÎLES CAÏMANS"},
    {code: "CF", name: "RÉPUBLIQUE CENTRAFRICAINE"},
    {code: "TD", name: "TCHAD"},
    {code: "CL", name: "CHILI"},
    {code: "CN", name: "CHINE"},
    {code: "CX", name: "L'ÎLE DE NOËL"},
    {code: "CC", name: "ÎLES COCOS (KEELING)"},
    {code: "CO", name: "COLOMBIE"},
    {code: "KM", name: "COMORES"},
    {code: "CG", name: "CONGO"},
    {code: "CD", name: "CONGO (RÉPUBLIQUE DÉMOCRATIQUE DU)"},
    {code: "CK", name: "LES ÎLES COOK"},
    {code: "CR", name: "COSTA RICA"},
    {code: "CI", name: "CÔTE D'IVOIRE"},
    {code: "HR", name: "CROATIE"},
    {code: "CU", name: "CUBA"},
    {code: "CW", name: "CURACAO (Pays-Bas)"},
    {code: "CY", name: "CHYPRE"},
    {code: "CZ", name: "RÉPUBLIQUE TCHÈQUE"},
    {code: "DK", name: "DANEMARK"},
    {code: "DJ", name: "DJIBOUTI"},
    {code: "DM", name: "DOMINIQUE"},
    {code: "DO", name: "RÉPUBLIQUE DOMINICAINE"},
    {code: "EC", name: "EQUATEUR"},
    {code: "EG", name: "EGYPTE"},
    {code: "SV", name: "LE SALVADOR"},
    {code: "GQ", name: "GUINÉE ÉQUATORIALE"},
    {code: "ER", name: "ERYTHREE"},
    {code: "EE", name: "ESTONIE"},
    {code: "ET", name: "ETHIOPIE"},
    {code: "FO", name: "ÎLES FEROE"},
    {code: "FJ", name: "FIDJI"},
    {code: "FI", name: "FINLANDE"},
    {code: "FR", name: "FRANCE"},
    {code: "PF", name: "POLYNÉSIE FRANÇAISE"},
    {code: "TF", name: "TERRITOIRES DU SUD FRANÇAIS"},
    {code: "GA", name: "GABON"},
    {code: "GM", name: "GAMBIE"},
    {code: "GE", name: "GÉORGIE"},
    {code: "DE", name: "ALLEMAGNE"},
    {code: "GH", name: "GHANA"},
    {code: "GI", name: "GIBRALTAR"},
    {code: "GR", name: "GRÈCE"},
    {code: "GL", name: "GROENLAND"},
    {code: "GD", name: "GRENADE"},
    {code: "GP", name: "ARCHIPEL DE GUADELOUPE"},
    {code: "GU", name: "GUAM"},
    {code: "GT", name: "GUATEMALA"},
    {code: "GG", name: "GUERNSEY (BAILIWICK DE)"},
    {code: "GN", name: "GUINÉE"},
    {code: "GW", name: "GUINÉE BISSAU"},
    {code: "GY", name: "GUYANE"},
    {code: "GF", name: "GUYANE (FRANÇAIS)"},
    {code: "HT", name: "HAÏTI"},
    {code: "HM", name: "HEARD ISLAND ET ÎLES MCDONALD"},
    {code: "VA", name: "SAINT-VOYAGE (VATICAN)"},
    {code: "HN", name: "HONDURAS"},
    {code: "HK", name: "HONG KONG SAR"},
    {code: "HU", name: "HONGRIE"},
    {code: "IS", name: "ISLANDE"},
    {code: "IN", name: "INDE"},
    {code: "ID", name: "INDONÉSIE"},
    {code: "IR", name: "IRAN"},
    {code: "IQ", name: "IRAK"},
    {code: "IE", name: "IRLANDE"},
    {code: "IL", name: "ISRAËL"},
    {code: "IT", name: "ITALIE"},
    {code: "JM", name: "JAMAÏQUE"},
    {code: "JP", name: "JAPON"},
    {code: "JE", name: "JERSEY"},
    {code: "JO", name: "JORDAN"},
    {code: "KZ", name: "KAZAKHSTAN"},
    {code: "KE", name: "KENYA"},
    {code: "KI", name: "KIRIBATI"},
    {code: "KR", name: "CORÉE"},
    {code: "KP", name: "RÉPUBLIQUE POPULAIRE DÉMOCRATIQUE DE CORÉE"},
    {code: "XK", name: "KOSOVO"},
    {code: "KW", name: "KOWEIT"},
    {code: "KG", name: "KYRGYZSTAN"},
    {code: "LA", name: "LAOS"},
    {code: "LV", name: "LETTONIE"},
    {code: "LB", name: "LIBAN"},
    {code: "LS", name: "LESOTHO"},
    {code: "LR", name: "LIBÉRIA"},
    {code: "LY", name: "LIBYE"},
    {code: "LI", name: "LIECHTENSTEIN"},
    {code: "LT", name: "LITUANIE"},
    {code: "LU", name: "LUXEMBOURG"},
    {code: "MO", name: "MACAO"},
    {code: "MG", name: "MADAGASCAR"},
    {code: "MW", name: "MALAWI"},
    {code: "MY", name: "MALAISIE"},
    {code: "MV", name: "MALDIVES"},
    {code: "ML", name: "MALI"},
    {code: "MT", name: "MALTE"},
    {code: "FK", name: "ILES FAKLAND (MALVINAS°"},
    {code: "IM", name: "ILE DE MAN"},
    {code: "MP", name: "ILES MARIANNES DU NORD"},
    {code: "MH", name: "ILES MARSHALL"},
    {code: "MQ", name: "MARTINIQUE"},
    {code: "MR", name: "MAURITANIE"},
    {code: "MU", name: "MAURICE"},
    {code: "YT", name: "MAYOTTE"},
    {code: "MX", name: "MEXIQUE"},
    {code: "FM", name: "MICRONÉSIE (ÉTATS FÉDÉRÉS DE)"},
    {code: "MD", name: "MOLDAVIE"},
    {code: "MC", name: "MONACO"},
    {code: "MN", name: "MONGOLIE"},
    {code: "ME", name: "MONTÉNÉGRO"},
    {code: "MS", name: "MONTSERRAT"},
    {code: "MA", name: "MAROC"},
    {code: "MZ", name: "MOZAMBIQUE"},
    {code: "MM", name: "MYANMAR"},
    {code: "NA", name: "NAMIBIE"},
    {code: "NR", name: "NAURU"},
    {code: "NP", name: "NÉPAL"},
    {code: "NL", name: "PAYS-BAS"},
    {code: "NC", name: "NOUVELLE CALÉDONIE"},
    {code: "NZ", name: "NOUVELLE-ZÉLANDE"},
    {code: "NI", name: "NICARAGUA"},
    {code: "NE", name: "NIGER"},
    {code: "NG", name: "NIGERIA"},
    {code: "NU", name: "NIUE"},
    {code: "NF", name: "L'ILE DE NORFOLK"},
    {code: "NO", name: "NORVÈGE"},
    {code: "OM", name: "OMAN"},
    {code: "PK", name: "PAKISTAN"},
    {code: "PW", name: "PALAU"},
    {code: "PS", name: "PALESTINE (Gaza Cisjordanie)"},
    {code: "PA", name: "PANAMA"},
    {code: "PG", name: "PAPOUASIE NOUVELLE GUINÉE"},
    {code: "PY", name: "PARAGUAY"},
    {code: "PE", name: "PÉROU"},
    {code: "PH", name: "PHILIPPINES"},
    {code: "PN", name: "ÎLE PITCAIRN"},
    {code: "PL", name: "POLOGNE"},
    {code: "PT", name: "LE PORTUGAL"},
    {code: "PR", name: "PORTO RICO"},
    {code: "QA", name: "QATAR"},
    {code: "MK", name: "RÉPUBLIQUE DE MACÉDOINE (LA)"},
    {code: "RE", name: "RÉUNION"},
    {code: "RO", name: "ROUMANIE"},
    {code: "RU", name: "RUSSIE"},
    {code: "RW", name: "RWANDA"},
    {code: "KN", name: "SAINT-CHRISTOPHE-ET-NIÉVÈS"},
    {code: "PM", name: "SAINT-PIERRE-ET-MIQUELON"},
    {code: "BL", name: "SAINT-BARTHÉLEMY"},
    {code: "SH", name: "ÎLE SAINTE-HÉLÈNE"},
    {code: "LC", name: "SAINTE-LUCIE"},
    {code: "MF", name: "SAINT MARTIN (PARTIE FRANÇAISE)"},
    {code: "VC", name: "SAINT-VINCENT-ET-LES-GRENADINES"},
    {code: "WS", name: "SAMOA"},
    {code: "SM", name: "SAINT MARIN"},
    {code: "ST", name: "SAO TOME ET PRINCIPE"},
    {code: "SA", name: "ARABIE SAOUDITE"},
    {code: "SN", name: "SÉNÉGAL"},
    {code: "RS", name: "SERBIE"},
    {code: "SC", name: "LES SEYCHELLES"},
    {code: "SL", name: "SIERRA LEONE"},
    {code: "SG", name: "SINGAPOUR"},
    {code: "SX", name: "SINT MAARTEN (PARTIE NÉERLANDAISE)"},
    {code: "SK", name: "SLOVAQUIE"},
    {code: "SI", name: "SLOVÉNIE"},
    {code: "SB", name: "LES ÎLES SALOMON"},
    {code: "SO", name: "SOMALIE"},
    {code: "ZA", name: "AFRIQUE DU SUD"},
    {code: "GS", name: "GÉORGIE DU SUD ET ÎLES SANDWICH DU SUD (SGSSI)"},
    {code: "SS", name: "SOUDAN DU SUD"},
    {code: "ES", name: "ESPAGNE"},
    {code: "LK", name: "SRI LANKA"},
    {code: "SD", name: "SOUDAN"},
    {code: "SR", name: "SURINAM"},
    {code: "SJ", name: "SVALBARD ET JAN MAYEN"},
    {code: "SZ", name: "SWAZILAND"},
    {code: "SE", name: "SUÈDE"},
    {code: "CH", name: "SUISSE"},
    {code: "SY", name: "SYRIE"},
    {code: "TW", name: "TAÏWAN"},
    {code: "TJ", name: "TAJIKISTAN"},
    {code: "TZ", name: "TANZANIE"},
    {code: "TH", name: "THAÏLANDE"},
    {code: "TL", name: "TIMOR-LESTE"},
    {code: "TG", name: "TOGO"},
    {code: "TK", name: "TOKELAU"},
    {code: "TO", name: "TONGA"},
    {code: "TT", name: "TRINITÉ-ET-TOBAGO"},
    {code: "TN", name: "TUNISIE"},
    {code: "TR", name: "TURQUIE"},
    {code: "TM", name: "TURKMÉNISTAN"},
    {code: "TC", name: "ÎLES TURQUES-ET-CAÏQUES"},
    {code: "TV", name: "TUVALU"},
    {code: "UG", name: "OUGANDA"},
    {code: "UA", name: "UKRAINE"},
    {code: "AE", name: "EMIRATS ARABES UNIS"},
    {code: "GB", name: "ROYAUME-UNI"},
    {code: "US", name: "ÉTATS UNIS"},
    {code: "UM", name: "ÎLES MINEURES ÉLOIGNÉES DES ÉTATS-UNIS"},
    {code: "VI", name: "ÎLES VIERGES DES ÉTATS-UNIS"},
    {code: "UY", name: "URUGUAY"},
    {code: "UZ", name: "OUZBÉKISTAN"},
    {code: "VU", name: "VANUATU"},
    {code: "VE", name: "VENEZUELA"},
    {code: "VN", name: "VIETNAM"},
    {code: "VG", name: "ÎLES VIERGES (BRITANNIQUES)"},
    {code: "WF", name: "WALLIS ET FUTUNA"},
    {code: "EH", name: "SAHARA OCCIDENTAL"},
    {code: "YE", name: "YÉMEN (RÉPUBLIQUE DU)"},
    {code: "ZM", name: "ZAMBIE"},
    {code: "ZW", name: "ZIMBABWE"}
];

export const COUNTRY_FRANCE_FIRST = [
    ...COUNTRY.filter((country) => country.code === "FR"),
    ...COUNTRY.filter((country) => country.code !== "FR"),
];
